import { useState, useEffect } from 'react';
import MessageBox from './MessageBox';
import ProfileMenu from './ProfileMenu';
import { useSidebar } from './SidebarContext';

const Navbar = () => {
  const isLoggedIn = localStorage.getItem('token');
  const [user, setUser] = useState(null);
  const { isSidebarOpen, setIsSidebarOpen } = useSidebar();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  if (!isLoggedIn) return null;

  const sidebarWidth = isSidebarOpen ? '15.6rem' : '4.4rem';
  const contentWidth = isSidebarOpen ? 'calc(100% - 15.6rem)' : 'calc(100% - 4rem)';

  return (
    <div
      style={{
        width: contentWidth,
        height: '3.5rem',
        backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: '2.2rem', // ❌ Remove left padding, keep right
        paddingLeft: '0',        // ✅ Ensure left is flush
        position: 'fixed',
        top: 0,
        left: sidebarWidth,
        zIndex: 1000,
        transition: 'all 0.3s ease',
      }}
    >
      {/* ✅ LEFT SIDE: Hamburger flush to left */}
      <div style={{ marginLeft: '1rem' }}>
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer',
            color: '#334155',
          }}
        >
          ☰
        </button>
      </div>

      {/* ✅ RIGHT SIDE: MessageBox, Profile */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
        <MessageBox />
        {user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            {user.image ? (
              <img
                src={user.image}
                alt="User Profile"
                style={{ width: '2.5rem', height: '2.5rem', borderRadius: '50%' }}
              />
            ) : (
              <div style={{ width: '2.5rem', height: '2.5rem', borderRadius: '50%', backgroundColor: '#ccc' }} />
            )}
            <span>{user.name}</span>
          </div>
        )}
        <ProfileMenu />
      </div>
    </div>
  );
};

export default Navbar;
